"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { useReducer, useState } from "react";
import {
  initialTableState,
  genericTableReducer
} from "../../Components/GenericTable/genericTableReducer";
import { candidatePoolAssignmentColumns } from "../CandidatePools/candidatePoolAssignmentConfig";
import { emailBatchColumns } from "../CandidatePools/emailBatchConfig";
import {
  candidateSourcingReducer,
  initialCandidateSourcingState
} from "../candidateSourcingReducer";
import CandidateSourcingApi from "../API";
export const useCandidatePoolModal = () => {
  const [selectedPool, setSelectedPool] = useState(void 0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTabValue, setModalTabValue] = useState(0);
  const [individualCandidatePoolsState, individualCandidatePoolsDispatch] = useReducer(
    genericTableReducer,
    initialTableState(candidatePoolAssignmentColumns, {
      sortBy: "name",
      sortOrder: "asc"
    })
  );
  const [emailsState, emailsDispatch] = useReducer(
    genericTableReducer,
    initialTableState(emailBatchColumns, {
      sortBy: "sent_at",
      sortOrder: "desc"
    })
  );
  const [candidateSourcingState, candidateSourcingDispatch] = useReducer(
    candidateSourcingReducer,
    initialCandidateSourcingState
  );
  const handlePoolClick = (poolId) => __async(void 0, null, function* () {
    try {
      const response = yield CandidateSourcingApi.getCandidatePool(poolId);
      const poolData = response.res;
      setSelectedPool(poolData);
      setIsModalOpen(true);
      setModalTabValue(0);
    } catch (error) {
      console.error("Error fetching pool data:", error);
    }
  });
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedPool(void 0);
    setModalTabValue(0);
  };
  const handleSnackbarState = (snackbarState) => {
    console.log("Snackbar state:", snackbarState);
  };
  return {
    selectedPool,
    isModalOpen,
    modalTabValue,
    individualCandidatePoolsState,
    individualCandidatePoolsDispatch,
    emailsState,
    emailsDispatch,
    candidateSourcingState,
    candidateSourcingDispatch,
    handlePoolClick,
    handleCloseModal,
    handleSnackbarState,
    setModalTabValue
  };
};
